module.exports = __webpack_public_path__ + "static/media/end-game-img.f7b7db14.png";